import React, { useState, useEffect } from 'react';
import { frontendDb as db } from '../../lib/frontend-db';
import type { ContactInfo } from '../../lib/frontend-db';

const ContactPage = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    id: '',
    address: '',
    email: '',
    rehearsal_time: '',
    rehearsal_location: '',
    section_title: 'Kontakt',
    rehearsal_location_label: 'Probenort:',
    rehearsal_time_label: 'Probenzeit:',
    email_label: 'E-Mail:',
    created_at: '',
    updated_at: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadContact();
  }, []);

  const loadContact = async () => {
    try {
      const contact = await db.getContact();
      if (contact) {
        setContactInfo(contact);
      }
    } catch (error) {
      console.error('Error loading contact:', error);
      setError('Fehler beim Laden der Kontaktinformationen');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);

    try {
      await db.updateContact(contactInfo);
      window.location.reload();
    } catch (error) {
      console.error('Error saving contact:', error);
      setError('Fehler beim Speichern der Kontaktinformationen');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse">Lädt...</div>;
  }

  return (
    <div className="space-y-6">
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      )}

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4 text-[var(--primary-color)]">{contactInfo.section_title || 'Kontaktinformationen'}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Sektions-Titel</label>
            <input
              type="text"
              value={contactInfo.section_title || ''}
              onChange={(e) => setContactInfo({ ...contactInfo, section_title: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              placeholder="z.B. Kontakt"
            />
            <p className="mt-1 text-xs text-gray-500">Diese Überschrift erscheint auf der Startseite und im Admin-Panel</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Label "Probenort"</label>
              <input
                type="text"
                value={contactInfo.rehearsal_location_label || ''}
                onChange={(e) => setContactInfo({ ...contactInfo, rehearsal_location_label: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
                placeholder="Probenort:"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Label "Probenzeit"</label>
              <input
                type="text"
                value={contactInfo.rehearsal_time_label || ''}
                onChange={(e) => setContactInfo({ ...contactInfo, rehearsal_time_label: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
                placeholder="Probenzeit:"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Label "E-Mail"</label>
              <input
                type="text"
                value={contactInfo.email_label || ''}
                onChange={(e) => setContactInfo({ ...contactInfo, email_label: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
                placeholder="E-Mail:"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">E-Mail</label>
            <input
              type="email"
              value={contactInfo.email}
              onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Probenort</label>
            <textarea
              value={contactInfo.rehearsal_location}
              onChange={(e) => setContactInfo({ ...contactInfo, rehearsal_location: e.target.value })}
              rows={3}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Probenzeit</label>
            <input
              type="text"
              value={contactInfo.rehearsal_time}
              onChange={(e) => setContactInfo({ ...contactInfo, rehearsal_time: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              required
            />
          </div>

          <button
            type="submit"
            disabled={saving}
            className="w-full bg-green-700 text-white py-2 px-4 rounded-md hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
          >
            {saving ? 'Wird gespeichert...' : 'Speichern'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPage;

